import React from 'react';

const Step3Tactical = ({ formData, updateFormData, onPrev, onComplete }) => {
  const handleRadioChange = (field, value) => {
    updateFormData(field, value);
    
    // Reset dependent fields when changing main questions
    if (field === 'tacticalStrategies') {
      updateFormData('tacticalActionSteps', '');
    }
  };

  const canProceed = () => {
    return formData.tacticalStrategies !== null &&
           ((formData.tacticalStrategies === true) || 
            (formData.tacticalStrategies === false && formData.tacticalActionSteps.trim() !== ''));
  };

  return (
    <div className="step-content">
      <h2 className="step-title">Step 3: Tactical Strategies</h2>
      
      {/* 3.1 Tactical Optimization Check */}
      <div className="question-container">
        <h3 style={{ marginBottom: '20px', color: '#333', fontSize: '1.3rem' }}>
          3.1 Tactical Optimization Check
        </h3>
        
        <div className="question-text">
          Have you implemented legal, timely, and wealth-enhancing tactical tax strategies?
        </div>
        
        <div className="radio-group">
          <div 
            className={`radio-option ${formData.tacticalStrategies === true ? 'selected' : ''}`}
            onClick={() => handleRadioChange('tacticalStrategies', true)}
          >
            <input
              type="radio"
              name="tacticalStrategies"
              checked={formData.tacticalStrategies === true}
              onChange={() => {}}
            />
            <label>Yes</label>
          </div>
          <div 
            className={`radio-option ${formData.tacticalStrategies === false ? 'selected' : ''}`}
            onClick={() => handleRadioChange('tacticalStrategies', false)}
          >
            <input
              type="radio"
              name="tacticalStrategies"
              checked={formData.tacticalStrategies === false}
              onChange={() => {}}
            />
            <label>No</label>
          </div>
        </div>

        {/* Show message or action input based on answer */}
        {formData.tacticalStrategies === true && (
          <div style={{ 
            background: '#e8f5e8', 
            padding: '15px', 
            borderRadius: '8px', 
            marginTop: '20px',
            borderLeft: '3px solid #4CAF50'
          }}>
            <strong style={{ color: '#2e7d32' }}>Fantastic! You are in great shape.</strong>
          </div>
        )}

        {formData.tacticalStrategies === false && (
          <div className="action-input-container">
            <div className="action-input-label">
              Please write down steps you will take to implement tactical strategies.
            </div>
            <textarea
              className="action-textarea"
              value={formData.tacticalActionSteps}
              onChange={(e) => updateFormData('tacticalActionSteps', e.target.value)}
              placeholder="Enter your action steps here..."
            />
          </div>
        )}
      </div>

      {/* Navigation */}
      <div className="navigation-buttons">
        <button
          className="btn btn-secondary"
          onClick={onPrev}
        >
          ← Back to Constitution Optimization
        </button>
        <button
          className="btn btn-success"
          onClick={onComplete}
          disabled={!canProceed()}
        >
          View Summary Report
        </button>
      </div>
    </div>
  );
};

export default Step3Tactical;
